import React from 'react';
import { Typography } from '@packages/ui/shared';
import { createUseStyles } from 'react-jss';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@web/components/table';

export interface JobPartItem {
    partNumber: string;
    partDescription: string;
    partQuantity: number;
}

interface JobPartsTableProps {
    parts: JobPartItem[];
    emptyMessage?: string;
}

const useStyles = createUseStyles({
    headerCell: {
        backgroundColor: '#F8F8F8',
        borderBottom: '1px solid #E3E3E3',
        '&:not(:last-child)': {
            borderRight: '1px solid #E3E3E3',
        },
    },
    emptyState: {
        padding: 12,
        fontStyle: 'italic',
    },
});

export const JobPartsTable: React.FC<JobPartsTableProps> = ({
    parts,
    emptyMessage = 'No Parts used for this job.',
}) => {
    const classes = useStyles();

    if (!parts || parts.length === 0) {
        return <div className={classes.emptyState}>{emptyMessage}</div>;
    }

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell width="15%" classNameOuter={classes.headerCell}>
                        <Typography variant="label">Quantity</Typography>
                    </TableCell>
                    <TableCell width="65%" classNameOuter={classes.headerCell}>
                        <Typography variant="label">Part Description</Typography>
                    </TableCell>
                    <TableCell width="20%" classNameOuter={classes.headerCell}>
                        <Typography variant="label">Part No</Typography>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {parts.map((p, idx) => (
                    <TableRow key={idx}>
                        <TableCell width="15%">
                            <Typography>{p.partQuantity}</Typography>
                        </TableCell>
                        <TableCell width="65%">
                            <Typography>{p.partDescription}</Typography>
                        </TableCell>
                        <TableCell width="20%">
                            <Typography>{p.partNumber}</Typography>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default JobPartsTable;
